/*
 * Public Surface of aumico-lib-integrations-fe (for TypeScript path-mapping).
 * Mirrored by src/public-api.ts which is the ng-packagr entry.
 */

// Module + config
export * from './aumico-lib-integrations-fe.module';
export * from './aumico-integrations.config';

// Models
export * from './models/integration/integration-vendor.enum';
export * from './models/integration/connection-mode.enum';
export * from './models/integration/connection-status.enum';
export * from './models/integration/integration-connection.model';
export * from './models/integration/vendor-badge-state.model';
export * from './models/integration/vendor-definition.model';
export * from './models/integration/vendor-definitions.constant';
export * from './models/integration/company-mapping-suggestion.model';
export * from './models/integration/abacus-connect.model';
export * from './models/integration/topal-connect.model';
export * from './models/integration/topal-import.model';
export * from './models/integration/accounto-connect.model';
export * from './models/integration/accounto-import.model';
export * from './utils/devtools-secret-sanitizer';
export * from './utils/api-key-expiry.util';
export * from './models/integration/proffix-connect.model';
export * from './models/integration/proffix-import.model';
export * from './models/integration/abacus-import.model';
export * from './models/integration/connection-mapping.model';
export * from './models/integration/d365bc-import.model';
export * from './models/integration/external-company.model';
export * from './models/integration/journal-import.model';

// Service
export * from './services/integration.service';
export * from './services/sharepoint-file-picker.service';

// NgRx
export * from './actions/integration.actions';
export * from './reducer/integration.feature-key';
export * from './reducer/integration.reducer';
export * from './selectors/integration.selectors';
export * from './effects/integration.effects';

// Provider (Facade)
export * from './provider/integration.provider';

// Components
export * from './components/integration-card/integration-card.component';
export * from './components/integration-sync-card/integration-sync-card.component';
export * from './components/integrations-search-company-input-field/integrations-search-company-input-field.component';
export * from './components/integration-go-to-admin-modal/integration-go-to-admin-modal.component';
export * from './components/integrations-overview/integrations-overview.component';
export * from './components/company-integrations-overview/company-integrations-overview.component';
export * from './components/vendor-org-redirect-modal/vendor-org-redirect-modal.component';
export * from './components/abacus-connect-modal/abacus-connect-modal.component';
export * from './components/topal-connect-modal/topal-connect-modal.component';
export * from './components/topal-manage-modal/topal-manage-modal.component';
export * from './components/accounto-connect-modal/accounto-connect-modal.component';
export * from './components/accounto-manage-modal/accounto-manage-modal.component';
export * from './components/proffix-connect-modal/proffix-connect-modal.component';
export * from './components/proffix-manage-modal/proffix-manage-modal.component';
export * from './components/abacus-manage-modal/abacus-manage-modal.component';
export * from './components/abacus-mapping-modal/abacus-mapping-modal.component';
export * from './components/d365bc-connect-modal/d365bc-connect-modal.component';
export * from './components/d365bc-manage-modal/d365bc-manage-modal.component';
export * from './components/company-mapping-modal/company-mapping-modal.component';
export * from './components/sharepoint-connect-modal/sharepoint-connect-modal.component';
export * from './components/sharepoint-manage-modal/sharepoint-manage-modal.component';
export * from './components/sharepoint-folders/sharepoint-folders.component';
export * from './components/sharepoint-folders/sharepoint-folders.types';
export * from './components/sharepoint-folders-container/sharepoint-folders-container.component';

// Outbound Partner-API clients (REV-21638)
export * from './models/outbound/partner-client.model';
export * from './models/outbound/partner-connection.model';
export * from './actions/partner-client.actions';
export * from './reducer/partner-client.feature-key';
export * from './reducer/partner-client.reducer';
export * from './selectors/partner-client.selectors';
export * from './effects/partner-client.effects';
export * from './services/partner-client.service';
export * from './services/partner-connection.service';
export * from './provider/partner-client.provider';
